<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <div class="row stacker-body">
        <div
          class="d-flex justify-content-between align-items-center globalborder-btm-header mb-3 pb-2 px-4">
          <span><h2 class="mb-0">User Account</h2></span>
          <span class="d-flex justify-content-between align-items-center gap-3">
            <span>
              <a class="dropdown-item d-flex align-items-center gap-2"
                ><span class="material-symbols-outlined"> theater_comedy </span>
                <div>Impersonate user</div>
              </a></span
            >
            <span
              ><a
                class="dropdown-item d-flex align-items-center gap-2"
                (click)="syncD365Data()">
                <i class="pi pi-sync"></i>
                <div>Sync</div>
              </a></span
            >
            <!-- <span
              class="d-flex justify-content-between align-items-center gap-2">
              <span class="toggle-hgt">
                <p-toggleswitch
                  [(ngModel)]="isProfileActive"
                  (onChange)="onProfileActiveToggleChanges($event)" />
              </span>
            </span> -->
            <span class="position-relative menu-drop">
              <p-menu #menu [model]="items" [popup]="true" />
              <p-button
                (click)="menu.toggle($event)"
                icon="pi pi-ellipsis-v"
                [link]="true" />
            </span>
            <span
              class="cross-border"
              *ngIf="isModal"
              (click)="closeProfileModalStacker()"
              ><i class="pi pi-times"></i
            ></span>
          </span>
        </div>

        <!-- <header
    class="user-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <div ngbDropdown>
      <a
        ngbDropdownToggle
        class="d-flex align-items-center justify-content-center">
      </a>

      <ul ngbDropdownMenu class="dropdown-menu py-3 mt-1">
        <li>
          <a
            class="dropdown-item"
            (keydown.enter)="updateUserProfileDataSilent()"
            (click)="updateUserProfileDataSilent()"
            (keydown.space)="updateUserProfileDataSilent()"
            tabindex="0"
            *ngIf="!disableSaveButton && profileForm.valid"
            >Confirm email</a
          >
        </li>
        <li>
          <a
            class="dropdown-item"
            (click)="refreshProfile()"
            (keydown.enter)="refreshProfile()"
            (keydown.space)="refreshProfile()"
            tabindex="0"
            >Refresh Profile
          </a>
        </li>
        <li>
          <a class="dropdown-item" (click)="syncD365Data()">Sync </a>
        </li>
        <li><a class="dropdown-item">Impersonate user</a></li>
        <li>
          <button class="dropdown-item" (click)="updateUserProfileData()">
            Save Profile
          </button>
        </li>
        <li>
          <button
            class="dropdown-item"
            (click)="generateReport()"
            *ngIf="
              getUserObject?.data?.loginEmail ===
                'portaltestsales@nadel.com' ||
              getUserObject?.data?.loginEmail === 'Anne.Thiongo@nadel.com'
            ">
            Generate Report
          </button>
        </li>
      </ul>
    </div>
  </header> -->
        <div class="col-12 px-4 user-container-hgt">
          <div class="row">
            <div class="col-3 pr-0 user-left-block">
              <jni-profile-form
                #profileFormCom
                (supportTableForSelf)="refreshTablForSelfUser($event)"
                [userId]="userId"
                [profileForm]="profileForm"
                (emitProfileFormChanges)="
                  getProfileFormChanges($event)
                "></jni-profile-form>
            </div>
            <div class="col-9">
              <jni-user-support-map
                gridheading="Who Supports Me"
                [userId]="userId.toString()"
                (refreshDataEvent)="refreshWhoSupportsMeAddTable()"
                [userProfileTableData]="whoSupportMeTableData"
                [userProfileAddTableData]="whoSupportMeAddTableData"
                (refreshDataIsPrimaryEvent)="refresIsPrimaryWhoSupportsMe()"
                (emitSupportUserModalShow)="showSupportUserProfileModal($event)"
                #whosupportsme>
              </jni-user-support-map>

              <jni-user-support-map
                gridheading="Who I Support"
                [userId]="userId.toString()"
                (refreshDataEvent)="refreshWhoISupportAddTable()"
                [userProfileTableData]="whoISupportTableData"
                [userProfileAddTableData]="whoISupportAddTableData"
                (refreshDataIsPrimaryEvent)="refresIsPrimaryDataWhoISupport()"
                (emitSupportUserModalShow)="showSupportUserProfileModal($event)"
                #whoisupport>
              </jni-user-support-map>
            </div>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>
<jni-modal-stacker
  *ngIf="userSupportProfileDisplayModal"
  [displayModal]="userSupportProfileDisplayModal"
  (closeEvent)="closeSupportUserProfileModal()">
  <div class="panelBody">
    <jni-profile
      #profile
      [userId]="selectedUserId"
      (emitCloseProfileModal)="closeSupportUserProfileModal()"
      [isModal]="true"></jni-profile>
  </div>
</jni-modal-stacker>
